import { render } from "./CUPartner.vue?vue&type=template&id=1e92d334&scoped=true"
import script from "./CUPartner.vue?vue&type=script&lang=js"
export * from "./CUPartner.vue?vue&type=script&lang=js"

import "./CUPartner.vue?vue&type=style&index=0&id=1e92d334&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e92d334"]])

export default __exports__